export var Request;
(function (Request) {
    function isBase(message) {
        return (typeof message === "object" && message !== null && "type" in message);
    }
    Request.isBase = isBase;
    function isInitWallet(message) {
        return (message.type === "INIT_WALLET" &&
            "privateKey" in message &&
            typeof message.privateKey === "string" &&
            "arkServerUrl" in message &&
            typeof message.arkServerUrl === "string" &&
            "network" in message &&
            typeof message.network === "string" &&
            ("arkServerPublicKey" in message
                ? typeof message.arkServerPublicKey === "string" ||
                    message.arkServerPublicKey === undefined
                : true));
    }
    Request.isInitWallet = isInitWallet;
    function isSettle(message) {
        return message.type === "SETTLE";
    }
    Request.isSettle = isSettle;
    function isGetAddress(message) {
        return message.type === "GET_ADDRESS";
    }
    Request.isGetAddress = isGetAddress;
    function isGetAddressInfo(message) {
        return message.type === "GET_ADDRESS_INFO";
    }
    Request.isGetAddressInfo = isGetAddressInfo;
    function isGetBalance(message) {
        return message.type === "GET_BALANCE";
    }
    Request.isGetBalance = isGetBalance;
    function isGetCoins(message) {
        return message.type === "GET_COINS";
    }
    Request.isGetCoins = isGetCoins;
    function isGetVtxos(message) {
        return message.type === "GET_VTXOS";
    }
    Request.isGetVtxos = isGetVtxos;
    function isGetVirtualCoins(message) {
        return message.type === "GET_VIRTUAL_COINS";
    }
    Request.isGetVirtualCoins = isGetVirtualCoins;
    function isGetBoardingUtxos(message) {
        return message.type === "GET_BOARDING_UTXOS";
    }
    Request.isGetBoardingUtxos = isGetBoardingUtxos;
    function isSendBitcoin(message) {
        return (message.type === "SEND_BITCOIN" &&
            "params" in message &&
            message.params !== null &&
            typeof message.params === "object" &&
            "address" in message.params &&
            typeof message.params.address === "string" &&
            "amount" in message.params &&
            typeof message.params.amount === "number");
    }
    Request.isSendBitcoin = isSendBitcoin;
    function isGetTransactionHistory(message) {
        return message.type === "GET_TRANSACTION_HISTORY";
    }
    Request.isGetTransactionHistory = isGetTransactionHistory;
    function isGetStatus(message) {
        return message.type === "GET_STATUS";
    }
    Request.isGetStatus = isGetStatus;
})(Request || (Request = {}));
